import { render } from "./MonthlyExpense.vue?vue&type=template&id=1a1d602f&scoped=true"
import script from "./MonthlyExpense.vue?vue&type=script&lang=js"
export * from "./MonthlyExpense.vue?vue&type=script&lang=js"

import "./MonthlyExpense.vue?vue&type=style&index=0&id=1a1d602f&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a1d602f"]])

export default __exports__